import ApiClient from '@/api/ApiClient';

const client = new ApiClient('client/orderClientProposal');

class OrderClientProposalApiClient {
	static update (updateOrderClientProposalModel: IUpdateOrderClientProposalModel) {
		return client.put<void>(`multiple`, updateOrderClientProposalModel);
	}

	static grid (orderClientProposalPagedListParameters: IUserClientProposalPagedListParameters) {
		return client.post<IPagedList<IOrderClientProposalWithUserModel>>('grid', orderClientProposalPagedListParameters);
	}

	static getDetails (id: number) {
		return client.get<IOrderClientProposalWithUserDetailsModel>(id.toString());
	}

	static count (orderId: number) {
		return client.get<IOrderClientProposalListCountForClientModel>(`count/${orderId}`);
	}
}

export default OrderClientProposalApiClient;
